<template>
  <div id="about-this-app">
    <call />
    <!-- header -->
    <top-bar title="このアプリについて" backUrl="/"/>
    <!-- main -->
    <main>
      <section>
        <div class="l-main--bg-border l-main--no-pd-bot l-main--grey" style="height: 100vh;">
          <div class="l-check-cart pt-60">
            <div class="l-check-cart__head">
              <div class="l-check-cart__head--icon">
                <img src="/assets/images/logo/logo-square.svg" alt="" />
              </div>
            </div>
            <div class="l-check-cart__body l-check-cart__body-padding mt-13">
              <div class="c-about-group mb-24">
                <div class="c-about-group__title">アプリケーション名</div>
                <div class="c-about-group__name">イオンタウンアプリ</div>
              </div>
              <div class="c-about-group mb-24">
                <div class="c-about-group__title">提供者</div>
                <div class="c-about-group__name">イオンタウン株式会社</div>
              </div>
              <div class="c-about-group mb-24">
                <div class="c-about-group__title">アプリのバージョン</div>
                <div class="c-about-group__name">{{getVersion()}}</div>
                <div class="c-about-group__name">(build:{{version}})</div>
              </div>
              <router-link to="/about/termsofuse" class="c-btn c-btn--center c-btn--white mb-10 font-size-14 font-bold" style="width: 100%;">
                ご利用規約
              </router-link>
              <router-link to="/about/open_source_license" class="c-btn c-btn--center c-btn--white font-size-14 font-bold" style="width: 100%;">
                オープンソースライセンス
              </router-link>
              <div class="user_id" @click.prevent="copyUid()">UID: {{$store.state.userId}}/{{$store.state.startCount}}</div>
            </div>
          </div>
        </div>
      </section>
      <footer-app></footer-app>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import { Tenant } from "../plugin/mixin.js";
import { Common } from "../common/common.js";
import TopBar from "../components/TopBar.vue";
import Footer from "../components/Footer.vue";

import Vue from "vue";
window._ver = "__VERSION__";

export default Vue.extend({
  name: 'About',
  components: {
    TopBar,
    'footer-app': Footer
  },
  data() {
    return {
      "version": "__VERSION__"
    }
  },
  mixins: [Tenant],
  mounted() {
    Common.initDom();
  },
  methods: {
    copyUid() {
      Common.messageHandlers("copy_text", { "text": this.$store.state.userId })
    }
  }
})
</script>